import React from 'react';
import './ContactUs.css';
import bgImage from '../bg-img.png';
import contactImage from '../contact.png';
import atIcon from '../at.png';
import handIcon from '../hand.png';
import musicIcon from '../music.png';
import homeLocIcon from '../home-loc.png';
import user11Icon from '../user11.png';
import mail11Icon from '../mail11.png';
import phone11Icon from '../phone11.png';
import me11Icon from '../me11.png';
import captions11Icon from '../captions11.png';
import message11Icon from '../message11.png';
import Contact from '../components/Contact';


const ContactUs = () => {
  return (
    <div className="contact-us-page">
      {/* Hero Section */}
      <section className="contact-hero-section">
        <div className="contact-hero-overlay">
          
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="contact-form-section">
        <div className="container">
          <div className="contact-form-content">
            <div className="contact-header">
              <h2 className="contact-title">Contact Us</h2>
              <p className="contact-subtitle">
                Have questions, feedback, or a gurukul to list?<br />
                We'd love to hear from you.
              </p>
            </div>

            <div className="contact-main">
              <div className="contact-info">
                <h3 className="contact-info-title">Get In Touch</h3>
                <p className="contact-info-description">
                  Our team replies within 48 hours on weekdays. For urgent verification requests, use
                  the "Claim Listing" workflow.
                </p>

                <div className="contact-cards">
                  <div className="contact-card">
                    <div className="contact-card-icon">
                      <img src={atIcon} alt="Email" />
                    </div>
                    <div className="contact-card-content">
                      <h4 className="contact-card-title">Email</h4>
                      <p className="contact-card-subtitle">General enquiries</p>
                      <p className="contact-card-email">contact@srivedagurukulam.org</p>
                    </div>
                  </div>

                  <div className="contact-card">
                    <div className="contact-card-icon">
                      <img src={handIcon} alt="Sponsors" />
                    </div>
                    <div className="contact-card-content">
                      <h4 className="contact-card-title">Sponsors</h4>
                      <p className="contact-card-subtitle">General enquiries</p>
                      <p className="contact-card-email">sponsors@srivedagurukulam.org</p>
                    </div>
                  </div>

                  <div className="contact-card">
                    <div className="contact-card-icon">
                      <img src={musicIcon} alt="Institution Support" />
                    </div>
                    <div className="contact-card-content">
                      <h4 className="contact-card-title">Institution Support</h4>
                      <p className="contact-card-subtitle">General enquiries</p>
                      <p className="contact-card-email">support@srivedagurukulam.org</p>
                    </div>
                  </div>

                  <div className="contact-card">
                    <div className="contact-card-icon">
                      <img src={homeLocIcon} alt="Address" />
                    </div>
                    <div className="contact-card-content">
                      <h4 className="contact-card-title">Address</h4>
                      <p className="contact-card-subtitle">FindMyGurukul, India</p>
                      <p className="contact-card-email">FindMyGurukul, India</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="contact-form">
                <div className="form-container">
                  <h3 className="form-title">Send Us a Message</h3>
                  
                  <form className="contact-form-fields">
                    <div className="form-group">
                      <div className="form-input-container">
                        <img src={user11Icon} alt="Name" className="form-icon" />
                        <label className="form-label">Full Name *</label>
                      </div>
                      <input type="text" className="form-input" placeholder="Your Full Name" />
                    </div>

                    <div className="form-group">
                      <div className="form-input-container">
                        <img src={mail11Icon} alt="Email" className="form-icon" />
                        <label className="form-label">Email Address *</label>
                      </div>
                      <input type="email" className="form-input" placeholder="Your Email Address" />
                    </div>

                    <div className="form-group">
                      <div className="form-input-container">
                        <img src={phone11Icon} alt="Phone" className="form-icon" />
                        <label className="form-label">Phone Number *</label>
                      </div>
                      <input type="tel" className="form-input" placeholder="Your Phone Number" />
                    </div>

                    <div className="form-group">
                      <div className="form-input-container">
                        <img src={me11Icon} alt="I am a" className="form-icon" />
                        <label className="form-label">I am a *</label>
                      </div>
                      <select className="form-input form-select">
                        <option value="">Select your role</option>
                        <option value="parent">Parent</option>
                        <option value="student">Student</option>
                        <option value="teacher">Teacher</option>
                        <option value="institution">Institution</option>
                        <option value="other">Other</option>
                      </select>
                    </div>

                    <div className="form-group">
                      <div className="form-input-container">
                        <img src={captions11Icon} alt="Subject" className="form-icon" />
                        <label className="form-label">Subject *</label>
                      </div>
                      <input type="text" className="form-input" placeholder="What is this about ?" />
                    </div>

                    <div className="form-group">
                      <div className="form-input-container">
                        <img src={message11Icon} alt="Message" className="form-icon" />
                        <label className="form-label">Message *</label>
                      </div>
                      <textarea className="form-input form-textarea" rows="5" placeholder="What is this about ?"></textarea>
                    </div>

                    <button type="submit" className="form-submit-btn">
                      <img src={message11Icon} alt="Send" className="btn-icon" />
                      Send Message
                    </button>

                    <p className="form-privacy">
                      By submitting this form, you agree to our <a href="#privacy">Privacy Policy</a>.
                      We'll only use your information to respond to your inquiry.
                    </p>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
            <Contact />

    </div>
  );
};

export default ContactUs;